import { createContext, use, useMemo, type ReactNode } from 'react'
import type { PassRepository } from './repository'
import { mockRepository } from './mock/mock-repository'

const RepositoryContext = createContext<PassRepository | null>(null)

export function RepositoryProvider({
  repository = mockRepository,
  children,
}: {
  readonly repository?: PassRepository | undefined
  readonly children: ReactNode
}) {
  const value = useMemo(() => repository, [repository])
  return <RepositoryContext value={value}>{children}</RepositoryContext>
}

export function useRepository(): PassRepository {
  const repository = use(RepositoryContext)
  if (!repository) throw new Error('useRepository must be used inside a RepositoryProvider')
  return repository
}
